import { MapIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { LinkButton, StateBlock } from '../components/ui';
import { usePageTitle } from '../hooks/usePageTitle';

const NotFound = () => {
    const { t } = useTranslation('auth');
    usePageTitle(t('notFound.title'));
    return (
        <StateBlock
            variant="empty"
            icon={MapIcon}
            heading="h1"
            title={t('notFound.title')}
            body={t('notFound.body')}
            action={
                <LinkButton to="/orders" variant="strong">
                    {t('notFound.action')}
                </LinkButton>
            }
        />
    );
};

export default NotFound;
